'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useSelector } from 'react-redux'
import { RootState } from 'features/store'
import { isUserAvailable } from 'helpers/authUser'
import { appHomePath } from '@/lib/appHomePath'

/** Same rule as the current home page: signed-in users never see the logged-out landing page. */
export default function LoggedInRedirect() {
  const router = useRouter()
  const user = useSelector((state: RootState) => state?.culineerAuth?.user)

  useEffect(() => {
    if (isUserAvailable(user)) router.push(appHomePath(user))
  }, [user, router])

  return null
}
